<div class="landing-page">
  <i class="landing-icon" [ngClass]="icon"></i>
  <h2 class="landing-title">{{title}}</h2>
  <div class="landing-message">{{message}}</div>
  <div class="actions">
    <ng-content></ng-content>
  </div>
</div>